import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { FunctionComponent, PropsWithChildren } from 'react';

export interface InfoLineProps extends PropsWithChildren {
    icon?: IconDefinition;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            alignItems: 'center'
        },
        icon: {
            marginRight: 8,
            width: 20
        },
        text: {
            fontSize: 14,
            lineHeight: '100%'
        }
    })
);

export const InfoLine: FunctionComponent<InfoLineProps> = props => {
    const classes = useStyles(props);

    return (
        <Box className={clsx(classes.container, props.className)}>
            {props.icon && (
                <FontAwesomeIcon
                    icon={props.icon}
                    fontSize={17}
                    className={classes.icon}
                />
            )}
            <Typography className={classes.text}>{props.children}</Typography>
        </Box>
    );
};

export default InfoLine;
